import { render, staticRenderFns } from "./SaveStatus.vue?vue&type=template&id=2ff0bbd8&scoped=true"
import script from "./SaveStatus.vue?vue&type=script&lang=js"
export * from "./SaveStatus.vue?vue&type=script&lang=js"
import style0 from "./SaveStatus.vue?vue&type=style&index=0&id=2ff0bbd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff0bbd8",
  null
  
)

export default component.exports